import mixpanel from "mixpanel-browser";
import { AnalyticsEventBus, event } from "../analytics";

export class HelpMenuMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.help_menu_action.new_users, (data) => {
      mixpanel.track(event.help_menu_action.new_users);
    });

    AnalyticsEventBus.$on(event.help_menu_action.manual_entrepreneur, (data) => {
      mixpanel.track(event.help_menu_action.manual_entrepreneur);
    });

    AnalyticsEventBus.$on(event.help_menu_action.manual_entrepreneur_en, (data) => {
      mixpanel.track(event.help_menu_action.manual_entrepreneur_en);
    });

    AnalyticsEventBus.$on(event.help_menu_action.manual_accountant, (data) => {
      mixpanel.track(event.help_menu_action.manual_accountant);
    });

    AnalyticsEventBus.$on(event.help_menu_action.manual_accountant_en, (data) => {
      mixpanel.track(event.help_menu_action.manual_accountant_en);
    });

    AnalyticsEventBus.$on(event.help_menu_action.beginning_balace_guide, (data) => {
      mixpanel.track(event.help_menu_action.beginning_balace_guide);
    });

    AnalyticsEventBus.$on(event.help_menu_action.user_guide, (data) => {
      mixpanel.track(event.help_menu_action.user_guide);
    });

    AnalyticsEventBus.$on(event.help_menu_action.parc, (data) => {
      mixpanel.track(event.help_menu_action.parc);
    });

    AnalyticsEventBus.$on(event.help_menu_action.assistant_for_you, (data) => {
      mixpanel.track(event.help_menu_action.assistant_for_you);
    });

    AnalyticsEventBus.$on(event.help_menu_action.lm, (data) => {
      mixpanel.track(event.help_menu_action.lm);
    });

    AnalyticsEventBus.$on(event.help_menu_action.video, (data) => {
      mixpanel.track(event.help_menu_action.video);
    });
  }
}
